<tc-launch-pad
        [blocks]="blocks"
        [isBlockFocus]="isBlockFocus"
        [focusActionIndex]="focusActionIndex"
        [focusBlockIndex]="focusBlockIndex"
        (select)="onActionClick($event)"
        #launch_pad>
</tc-launch-pad>
